const audiences = [
  { icon: "ri-bubble-chart-line", title: "爱刷短视频的你", desc: "梗的出处、事件的来龙去脉，看完不再「断网」。", tone: "bg-primary-100 text-primary-800" },
  { icon: "ri-quill-pen-line", title: "内容创作者", desc: "从爆款中提炼可复用的选题与传播方法，少走弯路。", tone: "bg-accent-100 text-accent-900" },
  { icon: "ri-team-line", title: "关注现象的人", desc: "把碎片热搜拼成完整线索，理解大众情绪与圈层文化。", tone: "bg-secondary-100 text-secondary-900" },
];

export default function AboutWall() {
  return (
    <section id="about" className="w-full bg-background-50 px-4 py-12 md:px-8 md:py-16 lg:px-14">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <p className="mb-2 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
              <i className="ri-flag-2-fill" aria-hidden="true"></i> 关于吃瓜爆网
            </p>
            <h2 className="font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
              做全网刷屏内容的「地图」，
              <br />
              <span className="text-primary-500">帮你把每一个热点看明白</span>
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-700">
              吃瓜爆网诞生于一个很朴素的困惑：当一个梗、一件事在一夜之间刷屏全网时，我们往往只能刷到「热闹」，却看不清「门道」——
              它从哪来、怎么传的、为什么让人上头、背后藏着怎样的圈层语言与大众情绪。
            </p>
            <p className="mt-3 text-base leading-relaxed text-foreground-700">
              所以我们把「吃瓜」做成一件认真的事：追踪网络爆传内容与转发过万出圈梗，拆解疯狂传播事件，坚持先核实、再复盘、有考据、不下结论带节奏。我们希望这里既是你的热点雷达，也是一本可以反复翻阅的互联网传播笔记。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3">
              {[
                ["定位", "全网热点追踪与传播复盘"],
                ["口号", "吃瓜，也要吃得明明白白"],
                ["内容", "热榜 / 栏目速览 / 深度盘点"],
              ].map(([k, v]) => (
                <div key={k}>
                  <p className="text-xs text-foreground-400">{k}</p>
                  <p className="mt-0.5 text-sm font-medium text-foreground-800">{v}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-1">
              {audiences.map((a) => (
                <div key={a.title} className="flex items-start gap-4 rounded-2xl border border-background-200 bg-background-100 p-5">
                  <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${a.tone}`}>
                    <i className={`${a.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="text-base font-semibold text-foreground-950">{a.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{a.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}